module.exports = __webpack_public_path__ + "static/img/autogood1.64e672e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/newdownload/autogood1.png
// module id = 8BFg
// module chunks = 0